import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useFavoriteNote = (facilityId: number, favoriteListId: number, note: string | null) => {
  async function fetchFavoriteNote(url: string) {
    try {
      const noteSent = note === '' ? null : note;
      const data = await fetcher.patch(url, { note: noteSent });

      if (data?.error) {
        return toast.error(`Не удалось обновить заметку: ${data?.error}`, { autoClose: 5000 });
      }

      toast.success('Заметка успешно обновлена', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось обновить заметку', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/${favoriteListId}/note/${facilityId}`,
    fetchFavoriteNote,
  );

  return { data, error, isMutating, ...rest };
};
export default useFavoriteNote;
